/**
 * MobileStatusBar - Status bar component for mobile emulator
 */
import React from 'react';
import { Smartphone, Wifi, WifiOff, Bug } from 'lucide-react';

interface MobileStatusBarProps {
  isOnline: boolean;
  onToggleOnline: () => void;
  onOpenDebug: () => void;
}

export const MobileStatusBar: React.FC<MobileStatusBarProps> = ({
  isOnline,
  onToggleOnline,
  onOpenDebug,
}) => {
  return (
    <div className="absolute top-0 left-0 right-0 h-16 bg-blue-600 text-white flex items-center justify-between px-4 z-10">
      <div className="flex items-center gap-2">
        <Smartphone className="w-4 h-4" />
        <span className="font-bold text-sm">logmed</span>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onOpenDebug}
          className="flex items-center gap-1 bg-red-500 hover:bg-red-400 px-3 py-1.5 rounded-full transition-colors border-2 border-red-300"
          title="Open Debug Panel"
          style={{
            fontSize: '12px',
            fontWeight: 'bold',
            minWidth: '70px',
            height: '32px',
            position: 'relative',
            zIndex: 9999
          }}
        >
          <Bug className="w-4 h-4 text-white" />
          <span className="text-xs font-bold text-white">DEBUG</span>
        </button>
        <button
          onClick={onToggleOnline}
          className="flex items-center gap-2 bg-white/20 hover:bg-white/30 px-3 py-1.5 rounded-full transition-colors"
        >
          {isOnline ? (
            <>
              <Wifi className="w-4 h-4 text-green-400" />
              <span className="text-xs font-medium">Online</span>
            </>
          ) : (
            <>
              <WifiOff className="w-4 h-4 text-red-400" />
              <span className="text-xs font-medium">Offline</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
};
